import { HeadGoverness } from 'vue-kindergarten';
import { redirectRoutes } from '@/kindergarten/perimeters';

export default class RouteGoverness extends HeadGoverness {
  constructor(perimeter) {
    super();
    this.perimeter = perimeter;
  }

  guard(action, { next }) {
    if (super.isNotAllowed(action)) {
      return next({
        name: redirectRoutes[this.perimeter],
      });
    }

    return next();
  }
}



// WEBPACK FOOTER //
// ./src/kindergarten/governesses/RouteGoverness.js